import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import idLocale from 'element-ui/lib/locale/lang/id'
import zhCnLocale from 'element-ui/lib/locale/lang/zh-CN'


import homeId from "./home_id"
import tableId from './table_data_id'

import homeZhCn from "./home_zh-CN"
import tableZhCn from './table_data_zh-CN'

Vue.use(VueI18n)
const messages = {
    id:  Object.assign(idLocale,homeId,tableId),
    zhCn: Object.assign(zhCnLocale,homeZhCn,tableZhCn)
}
const i18n = new VueI18n({
    locale: 'zhCn',
    fallbackLocale: 'zhCn',
    silentTranslationWarn: true,
    messages,
})
ElementLocale.i18n((key, value) => i18n.t(key, value))


export default i18n


// WEBPACK FOOTER //
// ./src/i18n/index.js